import React, { useState } from "react";
import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";

const CustomInput = ({
  control,
  name,
  rules = {},
  placeholder,
  isPassword = false,
  secureTextEntry = false,
  showPasswordGuide = false,
}) => {
  const { t } = useTranslation();
  const {
    field: { onChange, onBlur, value },
    fieldState: { error },
  } = useController({ name, control, rules });

  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasLowerCase, setHasLowerCase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);
  const [hasMinLength, setHasMinLength] = useState(false);

  const validatePassword = (text) => {
    setPassword(text);
    setHasUpperCase(/[A-Z]/.test(text));
    setHasLowerCase(/[a-z]/.test(text));
    setHasNumber(/[0-9]/.test(text));
    setHasSpecialChar(/[^A-Za-z0-9]/.test(text));
    setHasMinLength(text.length >= 8);
  };

  const handleChange = (e) => {
    const text = e.target.value;
    onChange(text);
    if (isPassword) {
      validatePassword(text);
    }
  };

  return (
    <div className="custom-input-container">
      <input
        type={
          isPassword && secureTextEntry && !showPassword ? "password" : "text"
        }
        name={name}
        value={value || ""}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        className={`custom-input ${error ? "input-error" : ""}`}
      />

      {isPassword && (
        <button
          type="button"
          className="toggle-password-btn"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? t("custom_input.hide") : t("custom_input.show")}
        </button>
      )}

      {error && <p className="error-text">{error.message}</p>}

      {showPasswordGuide && isPassword && (
        <div className="password-guide">
          <p className={hasUpperCase ? "valid" : "invalid"}>
            {t("custom_input.uppercase")}
          </p>
          <p className={hasLowerCase ? "valid" : "invalid"}>
            {t("custom_input.lowercase")}
          </p>
          <p className={hasNumber ? "valid" : "invalid"}>
            {t("custom_input.number")}
          </p>
          <p className={hasSpecialChar ? "valid" : "invalid"}>
            {t("custom_input.special")}
          </p>
          <p className={hasMinLength ? "valid" : "invalid"}>
            {t("custom_input.minLength")}
          </p>
        </div>
      )}
    </div>
  );
};

export default CustomInput;
